

import CommonApi from './../commonApi';
const contractVehiclePlanVehicle = new CommonApi(



  'contractVehiclePlanVehicle', 'ТС для плана НТС');
export default contractVehiclePlanVehicle;
